import { RemoteVideo, Flex } from '../../2022-component-library';

const FixationTargetVideo = ({ fixationTargetCoordinates, fixationSize }) => {
  const videoStyle = {
    width: fixationSize['x'],
    height: fixationSize['y'],
    zIndex: 9,
    top: fixationTargetCoordinates.y,
    left: fixationTargetCoordinates.x,
    transition: 'all 2s ease',
    position: 'absolute',
    cursor: 'none',
    marginTop: 0,
  };

  return (
    <Flex style={videoStyle}>
      <RemoteVideo />
    </Flex>
  );
};

export default FixationTargetVideo;
